import fetch from '@/service/fetch';

export function getList(params) {
  return fetch('/api/portal/msg/announcement/page', {
    data: params
  })
}

export function getNoticeDetail(params) {
  return fetch(`/api/portal/msg/announcement/find/${params.id}`)
}

export function getPublishDetail(params) {
  return fetch(`/api/portal/art/publication/find/${params.id}`)
}

export function getWikiDetail(params) {
  return fetch(`/api/portal/art/encyclopedias/find/${params.id}`)
}

export function getEduDetail(params) {
  return fetch(`/api/portal/art/education/find/${params.id}`)
}

export function getPolicyDetail(params) {
  return fetch(`/api/portal/art/policy/find/${params.id}`)
}

export function getNewsDetail(params) {
  return fetch(`/api/portal/art/news/find/${params.id}`)
}

export function getPartyDetail(params) {
  return fetch(`/api/portal/art/party/find/${params.id}`)
}
